export default "__VITE_ASSET__C7kSEVmZ__ 400w, __VITE_ASSET__BWeeHDk___ 800w, __VITE_ASSET__Bo3BOXwN__ 1200w";